import { Component, OnInit, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ApiService, } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsUtilities, RECENT_OPERATIONS_LIMIT } from "src/app/dvs-utilities";
import { DatetimePipe, RuntimePipe } from "src/app/pipes";
import { APIResults, } from "src/app/sharedinterfaces";

@Component({
	selector: "app-fdm",
	templateUrl: "./fdm.component.html",
	styleUrls: ["./fdm.component.scss"],
	imports: [FormsModule, RouterLink, RouterLinkActive, RouterOutlet, DatetimePipe, RuntimePipe]
})
export class FdmComponent implements OnInit {
	api = inject(ApiService);
	private charting = inject(ChartingService);
	readonly RECENT_OPERATIONS_LIMIT = RECENT_OPERATIONS_LIMIT;

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public GetOpClass = DvsUtilities.GetOpClass;
	public onlyExceedances = false;
	public showEmpty = false;
	public operations: APIResults.Operation[] = undefined;
	public selectedOperation;

	async ngOnInit() {
		await this.updateOperations();
	}

	async updateOperations() {
		this.operations = undefined;
		this.selectedOperation = undefined;
		const operations = await this.api.GetOperations(this.asset.asset_id, RECENT_OPERATIONS_LIMIT, this.showEmpty, this.onlyExceedances);
		this.operations = operations;
		if (this.operations.length > 0) {
			this.operationChange(this.operations[0]);
		}
	}

	private activeRouteComponent: any;
	async operationChange(operation: APIResults.Operation) {
		this.selectedOperation = operation;
		if (this.activeRouteComponent) {
			this.activeRouteComponent.operation = this.selectedOperation;
			if (this.activeRouteComponent.operationChange) this.activeRouteComponent.operationChange();
		}
	}

	public updateRouterOutlet(routecomponent?: any) {
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			this.activeRouteComponent.asset = this.asset;
			this.activeRouteComponent.fleet = this.fleet;
			this.activeRouteComponent.components = this.components;
			this.activeRouteComponent.operation = this.selectedOperation;
		}
	}
}
